export default __webpack_public_path__ + "static/media/Mechno-Leg-02.f11c5745.jpg";